import { render, staticRenderFns } from "./ChatWelcome.vue.js?vue&type=template&id=14823d70&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ChatWelcome.vue?vue&type=template&id=14823d70&scoped=true"
import script from "./ChatWelcome.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ChatWelcome.vue?vue&type=script&lang=js"
export * from "./ChatWelcome.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ChatWelcome.vue?vue&type=script&lang=js"
import style0 from "./ChatWelcome.vue.scss?vue&type=style&index=0&id=14823d70&lang=scss&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ChatWelcome.vue?vue&type=style&index=0&id=14823d70&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14823d70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14823d70')) {
      api.createRecord('14823d70', component.options)
    } else {
      api.reload('14823d70', component.options)
    }
    module.hot.accept("./ChatWelcome.vue.js?vue&type=template&id=14823d70&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ChatWelcome.vue?vue&type=template&id=14823d70&scoped=true", function () {
      api.rerender('14823d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/components/ChatFrame/ChatWelcome.vue"
export default component.exports